import React from "react";
import "./style.css";

const Spinner = () => {
  return <span className="loader"></span>;
};

export default Spinner;
